'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PlatformApi2 = require('./PlatformApi');

var _PlatformApi3 = _interopRequireDefault(_PlatformApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable sort-keys */
var endpoints = {
  adAccounts: {
    one: '/ad_accounts/{record}',
    params: {
      record: 'adAccountId'
    },
    queryParams: ['withLifetime'],

    search: {
      many: '/pacing/accounts',
      queryParams: ['query', 'limit', 'offset']
    }
  },
  impressionsOrderedRange: {
    one: '/impressions_ordered_range'
  },
  singleCompanyUser: {
    one: '/ihm_user/single_company'
  },
  ihmCampaigns: {
    many: '/ihm_campaigns',
    queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'mediaTypes', 'companyIds', 'searchBy', 'order_by', 'limit', 'offset']
  },
  subMediaTypeIHMCampaigns: {
    many: '/new_ihm_campaigns',
    queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'subMediaTypes', 'companyIds', 'searchBy', 'order_by', 'limit', 'offset']
  },
  initiativeGroupIHMCampaignsSelection: {
    many: '/initiative-groups/ihm_campaigns_selection',
    queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'subMediaTypes', 'companyIds', 'searchBy', 'order_by', 'limit', 'offset', 'customerOrderId']
  },
  initiativeGroupWithBundleIHMCampaignsSelection: {
    many: '/ihm_bundle/selection_page',
    queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'subMediaTypes', 'companyIds', 'market', 'searchBy', 'order_by', 'limit', 'offset', 'customerOrderId']
  },
  initiativeGroupIHMCampaigns: {
    many: '/initiative-groups/ihm_campaigns',
    queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'subMediaTypes', 'companyIds', 'searchBy', 'order_by', 'limit', 'offset']
  },
  initiativeGroupCustomerOrderIDs: {
    many: '/initiative-groups/customer_order_id',
    queryParams: ['order_id']
  },
  customerOrderIdIhmCampaigns: {
    many: '/campaign_selection_ihm_campaigns',
    queryParams: ['activeOrder', 'agencyCompany', 'impressionsOrderedMin', 'impressionsOrderedMax', 'startDate', 'endDate', 'mediaTypes', 'companyIds', 'searchBy', 'order_by', 'limit', 'offset', 'customerOrderId']
  },
  ihmCampaignSummary: {
    summary: {
      one: '/initiatives/{record}/ihm_summary',
      params: {
        record: 'initiativeId'
      }
    }
  },
  newIhmCampaignSummary: {
    details: {
      one: '/ihm_initiatives/{record}/details',
      params: {
        record: 'initiativeId'
      }
    }
  },
  subMediaTypeSummary: {
    details: {
      one: '/ihm_initiatives/sub_media_types/{record}/details',
      params: {
        record: 'initiativeId'
      }
    }
  },
  subMediaTypeInitiativeGroupDetails: {
    details: {
      one: '/ihm_initiative_groups/sub_media_types/{record}/details',
      params: {
        record: 'initiativeGroupId'
      }
    }
  },
  ihmCompanies: {
    details: {
      one: '/ihm_companies/{record}/details',
      params: {
        record: 'companyId'
      }
    },
    subMediaTypeDetails: {
      one: '/ihm_companies/sub_media_types/{record}/details',
      params: {
        record: 'companyId'
      }
    },
    summary: {
      one: '/ihm_companies/{record}/summary',
      params: {
        record: 'companyId'
      },
      queryParams: ['identityID', 'excludedInitiativeIDs', 'includedInitiativeIDs', 'mediaTypes', 'startDate', 'endDate']
    },
    subMediaTypeSummary: {
      one: '/ihm_companies/sub_media_types/{record}/summary',
      params: {
        record: 'companyId'
      },
      queryParams: ['identityID', 'excludedInitiativeIDs', 'includedInitiativeIDs', 'mediaTypes', 'startDate', 'endDate']
    },
    search: {
      many: '/ihm_companies/search',
      queryParams: ['disabled', 'foreignID', 'has_line_item', 'serviceType', 'accessRight', 'limit', 'offset', 'order_by', 'search', 'ids']
    },
    trimmedSearch: {
      many: '/ihm_companies/trimmed_search',
      queryParams: ['disabled', 'foreignID', 'has_line_item', 'serviceType', 'accessRight', 'limit', 'offset', 'order_by', 'search', 'ids']
    }
  },
  ihmBundle: {
    details: {
      one: '/ihm_bundle/{record}/details',
      params: {
        record: 'bundleId'
      }
    },
    summary: {
      one: '/ihm_bundle/{record}/summary',
      params: {
        record: 'bundleId'
      },
      queryParams: ['identityID', 'includedOpportunityIDs', 'excludedOpportunityIDs', 'mediaTypes', 'startDate', 'endDate']
    }
  },
  brands: {
    many: '/brands',
    one: '/brands/{record}',
    params: {
      record: 'brandId'
    },
    queryParams: ['limit', 'offset', 'withLifetime', 'disabled'],

    search: {
      many: '/brands/search',
      queryParams: ['companyID', 'disabled', 'familyID', 'foreignID', 'id', 'limit', 'offset', 'order_by', 'search', 'ownerCompanyID']
    },
    passThrough: {
      many: '/brands',
      queryParams: ['companyID', 'disabled', 'familyID', 'foreignID', 'id', 'limit', 'offset', 'order_by', 'search', 'query']
    },

    // Relationships
    company: {
      one: '/brands/{record}/company',
      params: {
        record: 'brandId'
      }
    },
    families: {
      one: '/brands/{record}/families',
      params: {
        record: 'brandId'
      }
    },
    initiatives: {
      one: '/brands/{record}/initiatives',
      params: {
        record: 'brandId'
      }
    },
    markets: {
      one: '/brands/{record}/markets',
      params: {
        record: 'brandId'
      }
    },
    properties: {
      one: '/brands/{record}/properties',
      params: {
        record: 'brandId'
      }
    },
    users: {
      one: '/brands/{record}/users',
      params: {
        record: 'brandId'
      }
    },
    agencies: {
      one: '/brands/{record}/agencies',
      params: {
        record: 'brandId'
      }
    },
    recover: {
      one: '/brands/{record}/recover',
      params: {
        record: 'brandId'
      }
    }
  },

  companies: {
    one: '/companies/{record}',
    many: '/companies',
    params: {
      record: 'companyId'
    },

    brands: {
      one: '/companies/{record}/brands',
      params: {
        record: 'companyId'
      },
      queryParams: ['limit', 'offset']
    },
    metrics: {
      one: '/companies/{record}/metrics',
      params: {
        record: 'companyId'
      },
      queryParams: ['disabled', 'publisher', 'brandID'],
      body: {
        brandId: 'brandId',
        denominator: 'denominator',
        formula: 'formula',
        isAdvanced: 'isAdvanced',
        metricType: 'metricType',
        name: 'name',
        numerator: 'numerator',
        publisher: 'publisher'
      }
    },
    queryParams: ['withLifetime'],
    search: {
      many: '/companies/search',
      queryParams: ['disabled', 'foreignID', 'has_line_item', 'serviceType', 'accessRight', 'limit', 'offset', 'order_by', 'search', 'ihmFlag', 'ids']
    },
    settings: {
      one: '/companies/{record}/settings',
      params: {
        record: 'companyId'
      }
    },
    users: {
      one: '/companies/{record}/users',
      params: {
        record: 'companyId'
      }
    },
    market: {
      one: '/companies/market/{record}',
      params: {
        record: 'marketId'
      }
    },
    child: {
      one: '/companies/{record}/companies',
      params: {
        record: 'companyId'
      }
    }
  },
  families: {
    one: '/families/{record}',
    many: '/families',
    params: {
      record: 'familyId'
    },

    brands: {
      one: '/families/{record}/brands',
      params: {
        record: 'familyId'
      }
    },
    company: {
      one: '/families/{record}/company',
      params: {
        record: 'familyId'
      }
    },
    creator: {
      one: '/families/{record}/creator',
      params: {
        record: 'familyId'
      }
    },
    queryParams: ['withLifetime'],
    search: {
      many: '/families/search',
      queryParams: ['brandID', 'companyID', 'disabled', 'limit', 'offset', 'order_by', 'search', 'userID']
    }
  },

  goals: {
    many: '/goals',
    one: '/goals/{record}',
    params: {
      record: 'goalId'
    },
    body: {
      actionType: 'actionType',
      denominator: 'denominator',
      formula: 'formula',
      goalType: 'goalType',
      indicatorName: 'indicatorName',
      isAdvanced: 'isAdvanced',
      lineItemId: 'lineItemId',
      metricType: 'metricType',
      numerator: 'numerator',
      pgField: 'pgField',
      position: 'position',
      value: 'value'
    }
  },

  initiatives: {
    many: '/initiatives',
    one: '/initiatives/{record}',
    params: {
      record: 'initiativeId'
    },
    body: {
      budget: 'budget',
      currency: 'currency',
      foreignID: 'foreignID',
      name: 'name'
    },

    search: {
      many: '/initiatives/search',
      queryParams: ['agencyID', 'brandID', 'companyID', 'createdOrWatchedBy', 'disabled', 'limit', 'offset', 'order_by', 'search', 'userID', 'publisher', 'query']
    },

    // Relationships
    brand: {
      one: '/initiatives/{record}/brand',
      params: {
        record: 'initiativeId'
      }
    },
    lineItems: {
      one: '/initiatives/{record}/line_items',
      params: {
        record: 'initiativeId'
      }
    },
    recover: {
      one: '/initiatives/{record}/recover',
      params: {
        record: 'initiativeId'
      }
    },
    agencies: {
      one: '/initiatives/{record}/agencies',
      params: {
        record: 'initiativeId'
      }
    }
  },

  initiativeGroups: {
    one: '/initiative-groups/{record}',
    params: {
      record: 'initiativeGroupId'
    }
  },

  lineItems: {
    many: '/line_items',
    one: '/line_items/{record}',
    params: {
      record: 'lineItemId'
    },
    queryParams: ['limit', 'offset'],
    body: {
      accountTimezone: 'accountTimezone',
      currency: 'currency',
      endDate: 'endDate',
      fee: 'fee',
      feePercentage: 'feePercentage',
      feeType: 'feeType',
      foreignID: 'foreignID',
      initiativeId: 'initiativeId',
      isContinuous: 'isContinuous',
      mediaSpend: 'mediaSpend',
      mediaType: 'mediaType',
      name: 'name',
      publisher: 'publisher',
      startDate: 'startDate',
      totalBudget: 'totalBudget'
    },

    // Relationship
    campaigns: {
      one: '/line_items/{record}/campaigns',
      params: {
        record: 'lineItemId'
      },
      register: {
        one: '/line_items/{record}/campaigns/register',
        params: {
          record: 'lineItemId'
        },
        queryParams: ['credentialId']
      }
    },

    goals: {
      one: '/line_items/{record}/goals',
      params: {
        record: 'lineItemId'
      }
    },
    markets: {
      one: '/line_items/{record}/markets',
      params: {
        record: 'lineItemId'
      }
    },

    search: {
      many: '/line_items/search',
      queryParams: ['accessRight', 'agencyID', 'archived', 'brandID', 'companyID', 'createdOrWatchedBy', 'deliveryStatus', 'disabled', 'disableGetCount', 'endDate', 'familyID', 'foreignID', 'filtering', 'initiativeID', 'limit', 'marketID', 'mediaType', 'offset', 'order_by', 'publisher', 'search', 'serviceType', 'startDate', 'userID', 'watchedBy', 'withAccess', 'withShare', 'withWatcher']
    }
  },

  markets: {
    search: {
      many: '/markets/search',
      queryParams: ['brandID', 'companyID', 'disabled', 'limit', 'offset', 'order_by', 'search', 'type', 'userID']
    }
  },

  initiativeGroupsReporting: {
    search: {
      many: '/initiative-groups-reporting',
      queryParams: ['companyIDs', 'familyIDs', 'brandIDs', 'limit', 'offset', 'order_by', 'query']
    }
  },

  metrics: {
    one: '/metrics/{record}',
    params: {
      record: 'customMetricId'
    }
  },

  properties: {
    one: '/properties/{record}',
    many: '/properties/',
    params: {
      record: 'propertyId'
    },
    body: {
      companyId: 'companyId',
      propertyUrl: 'propertyUrl',
      title: 'title',
      type: 'type'
    },

    brands: {
      one: '/properties/{record}/brands',
      params: {
        record: 'propertyId'
      }
    },

    search: {
      one: '/properties/search',
      queryParams: ['brandID', 'companyID', 'createdBy', 'disabled', 'limit', 'offset', 'order_by', 'search', 'type']
    }
  },

  reportTemplates: {
    many: '/report_templates',
    one: '/report_templates/{record}',
    params: {
      record: 'reportTemplateId'
    },
    body: {
      name: 'name',
      parameters: 'parameters',
      publisher: 'publisher',
      reportID: 'reportID'
    },

    search: {
      many: '/report_templates/search',
      queryParams: ['companyID', 'creatorID', 'isSystemTemplate', 'isIHMTemplate', 'limit', 'offset', 'order_by', 'publisher', 'reportID', 'search']
    },
    passThrough: {
      many: '/report_templates',
      queryParams: ['companyID', 'creatorID', 'isSystemTemplate', 'isIHMTemplate', 'limit', 'offset', 'order_by', 'publisher', 'reportID', 'search', 'query']
    },

    // Relationships
    creator: {
      one: '/report_templates/{record}/creator',
      params: {
        record: 'reportTemplateId'
      }
    },
    savedReports: {
      one: '/report_templates/{record}/saved_reports',
      params: {
        record: 'reportTemplateId'
      }
    },
    migrate: {
      one: '/report_templates/{record}/migrate',
      params: {
        record: 'reportTemplateId'
      },
      body: {
        name: 'name',
        parameters: 'parameters',
        reportID: 'reportID',
        reportTemplateId: 'reportTemplateId',
        savedReportID: 'savedReportID'
      }
    }
  },

  savedReports: {
    many: '/saved_reports',
    one: '/saved_reports/{record}',
    params: {
      record: 'savedReportId'
    },

    body: {
      name: 'name',
      parameters: 'parameters',
      publisher: 'publisher',
      reportID: 'reportID',
      templateID: 'templateID',
      scheduledReport: 'scheduledReport'
    },

    search: {
      many: '/saved_reports/search',
      queryParams: ['companyID', 'creatorID', 'createdFrom', 'createdTo', 'limit', 'offset', 'order_by', 'publisher', 'reportID', 'search', 'templateID']
    },

    // Relationships
    creator: {
      one: '/saved_reports/{record}/creator',
      params: {
        record: 'savedReportId'
      }
    },
    reportTemplate: {
      one: '/saved_reports/{record}/report_template',
      params: {
        record: 'savedReportId'
      }
    },
    scheduledReports: {
      one: '/saved_reports/{record}/scheduledReports',
      params: {
        record: 'savedReportId'
      }
    }
  },

  scheduledReports: {
    many: '/scheduled_reports',
    one: '/scheduled_reports/{record}',
    params: {
      record: 'scheduledReportId'
    },
    body: {
      body: '',
      cron: '',
      emails: [],
      endDate: '',
      exportBreakout: '',
      exportParams: '',
      frequency: '',
      reportID: '',
      reportName: '',
      scheduledMinuteOfDay: 0,
      scheduleName: '',
      scheduleTimezone: '',
      startDate: '',
      subject: '',
      templateID: '',
      timeOfDay: 0
    },

    search: {
      many: '/scheduled_reports/search',
      queryParams: ['creatorID', 'limit', 'offset', 'order_by', 'savedReportReportID', 'isIHMTemplate', 'search']
    },
    passThrough: {
      many: '/scheduled_reports',
      queryParams: ['creatorID', 'limit', 'offset', 'order_by', 'savedReportReportID', 'isIHMTemplate', 'query']
    },

    // Relationships
    creator: {
      one: '/scheduled_reports/{record}/creator',
      params: {
        record: 'scheduledReportId'
      }
    }
  },

  users: {
    many: '/users',
    one: '/users/{record}',
    params: {
      record: 'userId'
    },
    body: {
      remove_scheduled_reports: 'remove_scheduled_reports',
      remove_credentials: 'remove_credentials'
    },
    queryParams: ['limit', 'offset'],

    // Relationships
    brands: {
      one: '/users/{record}/brands',
      queryParams: ['disabled', 'limit', 'offset', 'order_by', 'search'],
      params: {
        record: 'userId'
      }
    },
    company: {
      one: '/users/{record}/company',
      params: {
        record: 'userId'
      }
    },
    session: {
      one: '/users/session'
    },
    search: {
      many: '/users/search',
      queryParams: ['search', 'disabled', 'offset', 'limit', 'admin', 'companyID', 'profileStatus', 'order_by']
    },
    recover: {
      one: '/users/{record}/recover',
      params: {
        record: 'userId'
      }
    },
    markets: {
      one: '/users/{record}/markets',
      params: {
        record: 'userId'
      }
    }
  },
  v2: {
    properties: {
      many: '/v2/properties',
      body: {
        companyId: 'companyId',
        propertyUrl: 'propertyUrl',
        title: 'title',
        type: 'type'
      }
    }
  },
  violation: {
    stats: {
      one: '/violation/stats',
      queryParams: ['includeUnsync', 'since']
    }
  }
  /* eslint-enable sort-keys */

};var defaultOptions = {
  prefix: '/pmn'
};

var PMNApi = function (_PlatformApi) {
  (0, _inherits3.default)(PMNApi, _PlatformApi);

  function PMNApi(options) {
    (0, _classCallCheck3.default)(this, PMNApi);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PMNApi.__proto__ || (0, _getPrototypeOf2.default)(PMNApi)).call(this, o));

    _this._endpoints = (0, _assign2.default)({}, _this._endpoints, endpoints);
    return _this;
  }

  return PMNApi;
}(_PlatformApi3.default);

exports.default = PMNApi;
//# sourceMappingURL=PMNApi.js.map